import * as React from "react";
import type { SVGProps } from "react";

interface StartProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Start = ({ cancelled = false, ...props }: StartProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <circle
        cx={12}
        cy={12}
        r={8.461}
        fill="#60B100"
        stroke="#FFF"
        strokeWidth={1.922}
      />
      <circle cx={12} cy={12} r={8.109} stroke="#000" strokeWidth={1.219} />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Start;
